import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  selector: 'shared-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  data = inject<{
    title?: string;
    message: string;
    buttons: {
        title: string;
        color: 'primary' | 'warn';
        value: boolean;
    }[];
}>(MAT_DIALOG_DATA);
}
